import {Ic} from "../../../../models/common";
import {IAppSpec} from "../../../../Redux/selector.state";
import {AcceptorOutputFn} from "../../../../models/acceptor/IAcceptor";
import {ISingleOutput} from "../../../../models/ISpec";
import {Utils} from "../../../../common/utils";
import {ValueFormatter} from "../../../../common/ValueFormatter";
import {siPrefix} from "../../../../common/siPrefix";
import {Acceptor_Common} from "../../../../models/acceptor/acceptor_common";
import {IC_fsw} from "../../../../models/IC_fsw";

/**
 * Created by claudio iozzia on 10/04/2017.
 */


export class Acceptor_AcDc_Buck extends Acceptor_Common {

  private acceptSingle_BUCK_Vout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const dMax = new IC_fsw(ic).dMax;
    const _vin_min_dc = spec.spec.value.input.min * Math.SQRT2;
    /* check if single voltage output is defined and inside the bounds */
    return ((Utils.isValueEmpty(out.voltage)) || ((ic.vout_min <= out.voltage && out.voltage <= ic.vout_max)))
      && ((Utils.isValueEmpty(out.voltage)) || (Utils.isValueEmpty(spec.spec.value.input.min)) || (Utils.isValueEmpty(dMax)) || (out.voltage < (_vin_min_dc * dMax)));
  }

  private acceptSingle_BUCK_Iout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    /* check if single current output is defined and inside the bounds */
    const IdLim: number = Utils.getFieldValue(ic, "designData.IdLim", 0);
    // let testIout = !isFinite(out.current) || out.current <= IdLim;
    // console.log("Buck I out", testIout);
    return Utils.isValueEmpty(out.current) || out.current <= ValueFormatter.scale(IdLim * 0.7, siPrefix.unit, 2, 'c');
  }

  private acceptSingle_BUCK_Pout: AcceptorOutputFn = (ic: Ic, spec: IAppSpec, out: ISingleOutput<number>): boolean => {
    const maxPower: number = Utils.getFieldValue(ic, "validator.power.max", Number.POSITIVE_INFINITY);

    // const eu:number = Utils.getFieldValue(a, "validator.power.maxEurope", NaN);
    // const wide:number = Utils.getFieldValue(a, "validator.power.maxWide", NaN);
    // const maxPower:number = Math.max(eu,wide)

    // console.log("Buck P out", testPout, out.current * out.voltage, maxPower);
    return Utils.isValueEmpty(out.current) || Utils.isValueEmpty(out.voltage)
      || (isFinite(maxPower) && (out.current * out.voltage <= maxPower));
  }


  protected singleOutputV(): AcceptorOutputFn {
    return this.acceptSingle_BUCK_Vout;
  }

  protected singleOutputI(): AcceptorOutputFn {
    return this.acceptSingle_BUCK_Iout;
  }

  protected singleOutputP(): AcceptorOutputFn {
    return this.acceptSingle_BUCK_Pout;
  }
}
